import { KnownError } from '@lmt/unicorn-shared/app/helpers/KnownError';
import i18next from 'i18next';
import { createContext } from 'use-context-selector';

export enum PatientTab {
  Overview = 'overview',
  Cases = 'cases',
}
export class PatientNotFoundError extends KnownError {
  constructor(message?: string) {
    super(
      message ?? i18next.t('translation:patients.overview.patient_not_found'),
    );
  }
}
export interface PatientProfileContextInterface {
  isEditCanceled: boolean;
  cancelEditing: (value: boolean) => void;
  hasUnsavedChanges: boolean;
  setUnsavedChanges: (key: string, value: boolean) => void;
  clearUnsavedChanges: () => void;
}

const defaultValues: PatientProfileContextInterface = {
  isEditCanceled: false,
  cancelEditing: () => undefined,
  hasUnsavedChanges: false,
  setUnsavedChanges: () => undefined,
  clearUnsavedChanges: () => undefined,
};
export const PatientProfileContext = createContext(defaultValues);
